/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-11 15:54:46
 */

import http from "@/api";

/**
 * @name 登录模块
 */
// * 用户所属团队列表
export const getTeamList = params => {
	return http.get(`/team/list`, params);
};

// 团队成员列表
export const getTeamMemberList = () => {
	return http.get(`/team/member/list`);
};

// 添加团队成员
export const getAddTeamMember = params => {
	return http.get(`/team/member/add`, params);
};

export const fetchChangeTeam = params => {
	return http.get("/team/switch", params);
};
/** 移除团队成员 */
export const removeTeamMember = params => {
	return http.get(`/team/member/remove`, params);
};

/** 客户列表 */
export const getClientList = params => {
	return http.get("/team/customer/list", params);
};

/** 新增客户 */
export const fetchAddTeamClient = params => {
	return http.post("/team/customer/add", params);
};

/** 更新团队信息 */
export const updateTeam = params => {
	return http.post("/team/update", params);
};
